import styled from 'styled-components';
import InfoIconMDI from 'mdi-react/InformationOutlineIcon';

export const LegendWrapper = styled.div(({ extra }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: extra ? 'space-between' : 'space-around',
}));

export const LegendLabels = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  color: '#707070',
  flexWrap: 'wrap',
});

export const Tooltip = {
  whiteSpace: 'nowrap',
  backgroundColor: 'rgba(92, 119, 235, 1)',
  color: 'white',
  userSelect: 'none',
  borderRadius: 3,
  padding: 5,
};

export const InfoIcon = styled(InfoIconMDI).attrs(p => ({
  color: p.theme.icons.secondary,
}))`
  cursor: pointer;
`;
